import { render, staticRenderFns } from "./TravelRestrictionList.vue?vue&type=template&id=674d9644"
import script from "./TravelRestrictionList.vue?vue&type=script&lang=js"
export * from "./TravelRestrictionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports